/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProposalViewModel } from './ProposalViewModel';
import {
    ProposalViewModelFromJSON,
    ProposalViewModelFromJSONTyped,
    ProposalViewModelToJSON,
} from './ProposalViewModel';

/**
 * 
 * @export
 * @interface ResultOfProposalViewModelAllOf
 */
export interface ResultOfProposalViewModelAllOf {
    /**
     * 
     * @type {ProposalViewModel}
     * @memberof ResultOfProposalViewModelAllOf
     */
    data?: ProposalViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProposalViewModelAllOf
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfProposalViewModelAllOf interface.
 */
export function instanceOfResultOfProposalViewModelAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfProposalViewModelAllOfFromJSON(json: any): ResultOfProposalViewModelAllOf {
    return ResultOfProposalViewModelAllOfFromJSONTyped(json, false);
}

export function ResultOfProposalViewModelAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfProposalViewModelAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'Data') ? undefined : ProposalViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfProposalViewModelAllOfToJSON(value?: ResultOfProposalViewModelAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Data': ProposalViewModelToJSON(value.data),
        'Count': value.count,
    };
}

